import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    // shopCode: Yup.lazy(value => (typeof value === 'object' ? Yup.object().nullable() : Yup.string().nullable())),
    rayCode: Yup.object().nullable().required('Raionul este obligatoriu'),
    // famCode: Yup.lazy(value => (typeof value === 'object' ? Yup.object().nullable() : Yup.string().nullable())),
    // sfaCode: Yup.lazy(value => (typeof value === 'object' ? Yup.object().nullable() : Yup.string().nullable())),
    // ubCode: Yup.lazy(value => (typeof value === 'object' ? Yup.object().nullable() : Yup.string().nullable())),
    // prodCode: Yup.string().nullable()
  })

const findMatchingRayonOption = (rayName: string | undefined, rayonOptions: AutocompleteOption[]) => {
  if (!rayName || !rayonOptions?.length) return null;

  const code = rayName.split(' ')[0];

  if (code) {
    const matchingOption = rayonOptions.find(option => option.value === code);

    if (matchingOption) {
      return {
        label: matchingOption.label,
        value: matchingOption.value
      };
    }
  }

  return null;
}

export const getInitialValues = (editItem: DLCProducts, rayonOptions: AutocompleteOption[]) => {
  return {
    shopCode: editItem?.shopCode || null,
    rayCode: editItem?.rayName ? findMatchingRayonOption(editItem.rayName, rayonOptions) : null,
    famCode: editItem?.famName || null,
    sfaCode: editItem?.sfaName || null,
    ubCode: editItem?.ubName || null,
    prodCode: editItem?.prodName || null,
    shopType: editItem?.shopType || null
  }
}
